﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListAbfall extends GuiListGeneric {

    constructor() {
        super("Abfall");

    }

}
